<script setup lang="ts">
const props = defineProps<{
  active: string
  sections?: string[]
}>()
const emit = defineEmits<{ go: [string] }>()
const site = useSiteStore()
// لوگوی برند کاربر برای نشان‌دادن در بالای ریل؛ ممکن است رشته یا آبجکت رسانه باشد.
const p = usePortfolioStore().profile
const logo = computed(() => resolveMediaUrl(p?.logo))
const logoAlt = computed(() => (p?.name ? `لوگوی ${p.name}` : 'لوگو'))
const items = [
  { id: 'hero', label: 'خانه', d: 'M3 10l9-7 9 7v9a2 2 0 01-2 2h-4v-6H9v6H5a2 2 0 01-2-2z' },
  { id: 'services', label: 'خدمات', d: 'M4 7h16v13H4zM9 7V4h6v3' },
  { id: 'projects', label: 'پروژه‌ها', d: 'M3 7h6l2 2h10v10H3z' },
  { id: 'contact', label: 'تماس', d: 'M3 6h18v12H3zM3 6l9 7 9-7' }
]
const visibleItems = computed(() =>
  Array.isArray(props.sections)
    ? items.filter(item => props.sections?.includes(item.id))
    : items
)
const showScrollTop = ref(false)
let heroObserver: IntersectionObserver | undefined
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onMounted(() => {
  const hero = document.getElementById('hero')
  if (!hero) return

  heroObserver = new IntersectionObserver(
    ([entry]) => {
      if (!entry) return
      showScrollTop.value = !entry.isIntersecting && entry.boundingClientRect.top < 0
    },
    { threshold: 0.05 }
  )
  heroObserver.observe(hero)
})

onBeforeUnmount(() => heroObserver?.disconnect())
</script>

<template>
  <!-- باند تمام‌قد: عرض باقی‌مانده را می‌گیرد و radius ندارد -->
  <div class="w-full self-stretch bg-surface-2 md:w-auto md:max-w-24 md:flex-[1_0_72px] sticky top-0 z-50">
    <nav class="sticky top-0 z-40 flex flex-row flex-wrap items-center justify-center gap-[18px] px-3.5 py-3
                md:h-dvh md:flex-col md:flex-nowrap md:justify-start md:px-3 md:py-6">
      <button title="باز کردن پروفایل" aria-label="باز کردن پروفایل" @click="site.toggleSideMenu()"
              class="grid h-[38px] w-[38px] place-content-center rounded-full bg-accent text-bg-deep glow md:hidden">
        <svg viewBox="0 0 24 24" class="h-[18px] w-[18px]" fill="none" stroke="currentColor" stroke-width="1.9"
             stroke-linecap="round"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
      </button>
      <button title="حالت تیره / روشن" aria-label="حالت تیره / روشن" @click="site.toggleTheme()"
              class="order-last grid h-[38px] w-[38px] place-content-center rounded-full bg-surface-2 text-ink transition
                     duration-300 hover:rotate-[35deg] md:order-none">
        <svg viewBox="0 0 24 24" class="h-[17px] w-[17px]" fill="none" stroke="currentColor" stroke-width="1.6">
          <circle cx="12" cy="12" r="8.5" /><path d="M12 3.5a8.5 8.5 0 000 17z" fill="currentColor" stroke="none" />
        </svg>
      </button>
      <!-- آیکون‌های ناوبری در میانه‌ی ارتفاع -->
      <div class="flex flex-row flex-wrap justify-center gap-[18px] md:my-auto md:flex-col">
      <button v-for="it in visibleItems" :key="it.id" @click="emit('go', it.id)" :title="it.label" :aria-label="it.label"
              class="grid h-10 w-10 place-content-center rounded-full transition duration-300 hover:-translate-y-0.5"
              :class="[
                active === it.id ? 'bg-accent text-bg-deep shadow-[var(--t-glow)]' : 'bg-line text-muted hover:text-accent',
                it.id === 'hero' && logo ? 'overflow-hidden !bg-surface ring-1 ring-line' : ''
              ]">
        <img v-if="it.id === 'hero' && logo" :src="logo" :alt="logoAlt" class="h-full w-full object-contain p-1" />
        <svg v-else viewBox="0 0 24 24" class="h-[18px] w-[18px]" fill="none" stroke="currentColor" stroke-width="1.8"
             stroke-linecap="round" stroke-linejoin="round"><path :d="it.d" /></svg>
      </button>
      <Transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="translate-y-2 opacity-0"
      leave-active-class="transition duration-200 ease-in"
      leave-to-class="translate-y-2 opacity-0"
    >
      <button
        v-if="showScrollTop"
        type="button"
        title="بازگشت به بالای صفحه"
        aria-label="بازگشت به بالای صفحه"
        class="mt-3 hidden h-11 w-11 place-content-center rounded-full border border-accent/40 bg-surface/90 text-accent
               shadow-[0_0_18px_var(--t-accent-soft)] backdrop-blur-xl transition duration-300
               hover:-translate-y-1 hover:border-accent hover:bg-[var(--t-accent-soft)] hover:text-accent-2 md:grid"
        @click="scrollToTop"
      >
        <svg
          viewBox="0 0 24 24"
          class="h-5 w-5"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 19V5M6.5 10.5 12 5l5.5 5.5" />
        </svg>
      </button>
    </Transition>
      </div>
    </nav>
  </div>
</template>
